// Code generated by tygo. DO NOT EDIT.

//////////
// source: enums.go

export type SecurityMethod = string;
export const Main: SecurityMethod = "main";
export const Standard: SecurityMethod = "standard";
export const High: SecurityMethod = "high";
export const VEITS: SecurityMethod = "VEITS";
